import da from "element-ui/src/locale/lang/da";

let state = {
    urlArr: '',
    urlMap: '',
    shop: '',
    bottomIdx: 0,
    ApplyId: '',
    ApplyTel: '',
    GetListResult: [],
    areaList: [],
    CurrentPage: '',
}

let getters = {

}

let actions = {

}

let mutations = {
    UpUrlArr(state, data) {
        state.urlArr = data
    },
    UpUrlMap(state, data) {
        state.urlMap = data
    },
    UpShop(state, data) {
        state.shop = data
    },
    upBottomIdx(state, idx) {
        state.bottomIdx = idx
    },
    upApplyId(state, idx) {
        state.ApplyId = idx
    },
    upApplyTel(state, idx) {
        state.ApplyTel = idx
    },
    upGetListResult(state, idx) {
        state.GetListResult = idx
    },
    setAreaList(state, data) {
      state.areaList = data;
    },
    upCurrentPage(state, idx) {
        state.CurrentPage = idx
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}